import { createFeature, createReducer, on } from '@ngrx/store';
import { Customer } from '~move-device/models/customer';
import { MoveDeviceActions } from '~move-device/store/move-device.actions';
import { LoadingState, StatusState } from '~shared/models/status-state';

export const moveDeviceFeatureKey = 'moveDevice';

export interface moveDeviceState {
    status: StatusState;
    customers: Customer[];
    errorMsg: string | null;
}

export const initialState: moveDeviceState = {
    status: LoadingState.default,
    customers: [],
    errorMsg: null,
};

export const moveDeviceReducer = createReducer(
    initialState,
    on(MoveDeviceActions.loadCustomers, (state) => ({
        ...state,
        status: LoadingState.loading,
        customers: [],
        errorMsg: null,
    })),
    on(MoveDeviceActions.loadCustomersSuccess, (state, { customers }) => ({
        ...state,
        status: LoadingState.default,
        customers,
        errorMsg: null,
    })),
    on(MoveDeviceActions.loadCustomersFailure, (state, { error }) => ({
        ...state,
        status: LoadingState.default,
        customers: [],
        errorMsg: error,
    })),
    on(MoveDeviceActions.moveDevice, (state) => ({
        ...state,
        status: LoadingState.loading,
        errorMsg: null,
    })),
    on(MoveDeviceActions.moveDeviceSuccess, (state) => ({
        ...state,
        status: LoadingState.default,
        errorMsg: null,
    })),
    on(MoveDeviceActions.moveDeviceFailure, (state, { error }) => ({
        ...state,
        status: LoadingState.default,
        errorMsg: error,
    }))
);

export const MoveDeviceFeature = createFeature({
    name: moveDeviceFeatureKey,
    reducer: moveDeviceReducer,
});
